export const mixinCourseDiscount = {
  methods: {
    __convertBonusPointToAmount(priceSettings, bonusPoint) {
      let amount = 0;

      let bonusPointToMoney_BonusPoint = priceSettings.bonusPointToMoney_BonusPoint;
      let bonusPointToMoney_Money = priceSettings.bonusPointToMoney_Money;

      if (bonusPointToMoney_BonusPoint > 0) {
        amount = (bonusPoint * bonusPointToMoney_Money / bonusPointToMoney_BonusPoint).toFixedEx(2);
      }

      return amount;
    },
    //重新分配课程分摊抵扣
    __reallocateCourseDiscount(priceSettings, courseList, bonusPoint, cashDecreased) {
      let [...tempCourseList] = courseList;
      let lastCourse = tempCourseList.pop();
      let couponDiscountTotalPrice = courseList.sum(course => course.priceData.couponDiscountPrice);
      tempCourseList.forEach(course => {
        let courseRate = couponDiscountTotalPrice > 0 ? course.priceData.couponDiscountPrice / couponDiscountTotalPrice : 0;
        let courseBonusPoint = (bonusPoint * courseRate).toFixedEx(0);
        let courseBonusPointAmount = this.__convertBonusPointToAmount(priceSettings, courseBonusPoint);
        let courseCashDecreased = (cashDecreased * courseRate).toFixedEx(2);
        let courseSubtotal = (course.priceData.couponDiscountPrice - courseBonusPointAmount - courseCashDecreased).toFixedEx(2);;

        this.$set(course.priceData, "bonusPointCost", courseBonusPoint);
        this.$set(course.priceData, "oldBonusPointCost", courseBonusPoint);
        this.$set(course.priceData, "bonusPointAmount", courseBonusPointAmount);
        this.$set(course.priceData, "cashDecreasedAmount", courseCashDecreased);
        this.$set(course.priceData, "subtotal", courseSubtotal);
      });
      if (!!lastCourse) {
        let ocBonusPointTotal = tempCourseList.sum(course => course.priceData.bonusPointCost);
        let ocCashDecreasedTotal = tempCourseList.sum(course => course.priceData.cashDecreasedAmount);
        let courseBonusPoint = (bonusPoint - ocBonusPointTotal).toFixedEx(0);
        let courseBonusPointAmount = this.__convertBonusPointToAmount(priceSettings, courseBonusPoint);
        let courseCashDecreased = (cashDecreased - ocCashDecreasedTotal).toFixedEx(2);
        let courseSubtotal = (lastCourse.priceData.couponDiscountPrice - courseBonusPointAmount - courseCashDecreased).toFixedEx(2);

        this.$set(lastCourse.priceData, "bonusPointCost", courseBonusPoint);
        this.$set(lastCourse.priceData, "oldBonusPointCost", courseBonusPoint);
        this.$set(lastCourse.priceData, "bonusPointAmount", courseBonusPointAmount);
        this.$set(lastCourse.priceData, "cashDecreasedAmount", courseCashDecreased);
        this.$set(lastCourse.priceData, "subtotal", courseSubtotal);
      }
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/addCollectFees/courseEnrollmentFee/mixin.js